import { Iata } from 'types/Search/airport';

import {
    AirportCountry,
    AirportMap,
    Country,
    Region,
    RegionAirportList,
} from '../types';

// All airports
export const airportList: AirportMap = {
    [Iata.ACH]: {
        label: 'TRANS-ACH',
        country: Country.Switzerland,
    },
    [Iata.AMS]: {
        label: 'TRANS-AMS',
        country: Country.Netherlands,
    },
    [Iata.BER]: {
        label: 'TRANS-BER',
        country: Country.Germany,
    },
    [Iata.BLL]: {
        label: 'TRANS-BLL',
        country: Country.Denmark,
    },
    [Iata.BRE]: {
        label: 'TRANS-BRE',
        country: Country.Germany,
    },
    [Iata.BRN]: {
        label: 'TRANS-BRN',
        country: Country.Switzerland,
    },
    [Iata.BRU]: {
        label: 'TRANS-BRU',
        country: Country.Belgium,
    },
    [Iata.BSL]: {
        label: 'TRANS-BSL',
        country: Country.Switzerland,
    },
    [Iata.CGN]: {
        label: 'TRANS-CGN',
        country: Country.Germany,
    },
    [Iata.CRL]: {
        label: 'TRANS-CRL',
        country: Country.Belgium,
    },
    [Iata.DRS]: {
        label: 'TRANS-DRS',
        country: Country.Germany,
    },
    [Iata.DTM]: {
        label: 'TRANS-DTM',
        country: Country.Germany,
    },
    [Iata.DUS]: {
        label: 'TRANS-DUS',
        country: Country.Germany,
    },
    [Iata.EIN]: {
        label: 'TRANS-EIN',
        country: Country.Netherlands,
    },
    [Iata.ERF]: {
        label: 'TRANS-ERF',
        country: Country.Germany,
    },
    [Iata.FDH]: {
        label: 'TRANS-FDH',
        country: Country.Germany,
    },
    [Iata.FKB]: {
        label: 'TRANS-FKB',
        country: Country.Germany,
    },
    [Iata.FMM]: {
        label: 'TRANS-FMM',
        country: Country.Germany,
    },
    [Iata.FMO]: {
        label: 'TRANS-FMO',
        country: Country.Germany,
    },
    [Iata.FRA]: {
        label: 'TRANS-FRA',
        country: Country.Germany,
    },
    [Iata.GRQ]: {
        label: 'TRANS-GRQ',
        country: Country.Netherlands,
    },
    [Iata.GRZ]: {
        label: 'TRANS-GRZ',
        country: Country.Austria,
    },
    [Iata.GVA]: {
        label: 'TRANS-GVA',
        country: Country.Switzerland,
    },
    [Iata.GWT]: {
        label: 'TRANS-GWT',
        country: Country.Germany,
    },
    [Iata.HAJ]: {
        label: 'TRANS-HAJ',
        country: Country.Germany,
    },
    [Iata.HAM]: {
        label: 'TRANS-HAM',
        country: Country.Germany,
    },
    [Iata.HHN]: {
        label: 'TRANS-HHN',
        country: Country.Germany,
    },
    [Iata.INN]: {
        label: 'TRANS-INN',
        country: Country.Austria,
    },
    [Iata.KLU]: {
        label: 'TRANS-KLU',
        country: Country.Austria,
    },
    [Iata.KRK]: {
        label: 'TRANS-KRK',
        country: Country.Poland,
    },
    [Iata.KSF]: {
        label: 'TRANS-KSF',
        country: Country.Germany,
    },
    [Iata.LBC]: {
        label: 'TRANS-LBC',
        country: Country.Germany,
    },
    [Iata.LEJ]: {
        label: 'TRANS-LEJ',
        country: Country.Germany,
    },
    [Iata.LGG]: {
        label: 'TRANS-LGG',
        country: Country.Belgium,
    },
    [Iata.LNZ]: {
        label: 'TRANS-LNZ',
        country: Country.Austria,
    },
    [Iata.LUX]: {
        label: 'TRANS-LUX',
        country: Country.Luxembourg,
    },
    [Iata.MST]: {
        label: 'TRANS-MST',
        country: Country.Netherlands,
    },
    [Iata.MUC]: {
        label: 'TRANS-MUC',
        country: Country.Germany,
    },
    [Iata.NRN]: {
        label: 'TRANS-NRN',
        country: Country.Germany,
    },
    [Iata.NUE]: {
        label: 'TRANS-NUE',
        country: Country.Germany,
    },
    [Iata.PAD]: {
        label: 'TRANS-PAD',
        country: Country.Germany,
    },
    [Iata.PRG]: {
        label: 'TRANS-PRG',
        country: Country.CzechRepublic,
    },
    [Iata.RLG]: {
        label: 'TRANS-RLG',
        country: Country.Germany,
    },
    [Iata.SCN]: {
        label: 'TRANS-SCN',
        country: Country.Germany,
    },
    [Iata.STR]: {
        label: 'TRANS-STR',
        country: Country.Germany,
    },
    [Iata.SXB]: {
        label: 'TRANS-SXB',
        country: Country.France,
    },
    [Iata.SZG]: {
        label: 'TRANS-SZG',
        country: Country.Austria,
    },
    [Iata.VIE]: {
        label: 'TRANS-VIE',
        country: Country.Austria,
    },
    [Iata.WAW]: {
        label: 'TRANS-WAW',
        country: Country.Poland,
    },
    [Iata.ZRH]: {
        label: 'TRANS-ZRH',
        country: Country.Switzerland,
    },
    [Iata.LUG]: {
        label: 'TRANS-LUG',
        country: Country.Switzerland,
    },
    [Iata.LIN]: {
        label: 'TRANS-LIN',
        country: Country.Italy,
    },
    [Iata.MXP]: {
        label: 'TRANS-MXP',
        country: Country.Italy,
    },
    [Iata.BTS]: {
        label: 'TRANS-BTS',
        country: Country.Slovakia,
    },
    [Iata.LJU]: {
        label: 'TRANS-LJU',
        country: Country.Slovenia,
    },
};

// Regions by country
export const AirportRegionList_DE: RegionAirportList[] = [
    {
        region: Region.North,
        iataCodeList: new Set([
            Iata.HAM,
            Iata.HAJ,
            Iata.BRE,
            Iata.RLG,
            Iata.LBC,
            Iata.GWT,
        ]),
    },
    {
        region: Region.East,
        iataCodeList: new Set([
            Iata.BER,
            Iata.LEJ,
            Iata.DRS,
            Iata.ERF,
        ]),
    },
    {
        region: Region.South,
        iataCodeList: new Set([
            Iata.MUC,
            Iata.STR,
            Iata.NUE,
            Iata.FKB,
            Iata.FMM,
            Iata.FDH,
        ]),
    },
    {
        region: Region.West,
        iataCodeList: new Set([
            Iata.DUS,
            Iata.FRA,
            Iata.CGN,
            Iata.PAD,
            Iata.FMO,
            Iata.SCN,
            Iata.HHN,
            Iata.KSF,
            Iata.NRN,
            Iata.DTM,
        ]),
    },
];

//airports and regions by country
export const AirportList_DE: AirportCountry = {
    regionList: AirportRegionList_DE,
    iataCodeList: new Set([
        Iata.BER,
        Iata.BRE,
        Iata.CGN,
        Iata.DRS,
        Iata.DTM,
        Iata.DUS,
        Iata.ERF,
        Iata.FDH,
        Iata.FKB,
        Iata.FMM,
        Iata.FMO,
        Iata.FRA,
        Iata.GWT,
        Iata.HAJ,
        Iata.HAM,
        Iata.HHN,
        Iata.KSF,
        Iata.LBC,
        Iata.LEJ,
        Iata.MUC,
        Iata.NRN,
        Iata.NUE,
        Iata.PAD,
        Iata.RLG,
        Iata.SCN,
        Iata.STR,
    ]),
    active: true,
};

export const AirportList_CH: AirportCountry = {
    iataCodeList: new Set([Iata.ACH, Iata.BRN, Iata.BSL, Iata.GVA, Iata.ZRH, Iata.LUG]),
    active: true,
};

export const AirportList_AT: AirportCountry = {
    iataCodeList: new Set([
        Iata.VIE,
        Iata.GRZ,
        Iata.INN,
        Iata.KLU,
        Iata.LNZ,
        Iata.SZG,
    ]),
    active: true,
};

export const AirportList_NL: AirportCountry = {
    iataCodeList: new Set([Iata.EIN, Iata.GRQ, Iata.MST, Iata.AMS]),
    active: true,
};

export const AirportList_CZ: AirportCountry = {
    iataCodeList: new Set([Iata.PRG]),
    active: true,
};

export const AirportList_LU: AirportCountry = {
    iataCodeList: new Set([Iata.LUX]),
    active: true,
};

export const AirportList_BE: AirportCountry = {
    iataCodeList: new Set([Iata.BRU, Iata.CRL, Iata.LGG]),
    active: true,
};

export const AirportList_F: AirportCountry = {
    iataCodeList: new Set([Iata.SXB]),
    active: true,
};

export const AirportList_DK: AirportCountry = {
    iataCodeList: new Set([Iata.BLL]),
    active: true,
};

export const AirportList_PL: AirportCountry = {
    iataCodeList: new Set([Iata.KRK, Iata.WAW]),
    active: true,
};

export const AirportList_IT: AirportCountry = {
    iataCodeList: new Set([Iata.LIN, Iata.MXP]),
    active: true,
};

export const AirportList_SK: AirportCountry = {
    iataCodeList: new Set([Iata.BTS]),
    active: true,
};

export const AirportList_SI: AirportCountry = {
    iataCodeList: new Set([Iata.LJU]),
    active: true,
};

// available countries
export const ListByCountries: Record<Country, AirportCountry> = {
    [Country.Germany]: AirportList_DE,
    [Country.Austria]: AirportList_AT,
    [Country.Switzerland]: AirportList_CH,
    [Country.Belgium]: AirportList_BE,
    [Country.Denmark]: AirportList_DK,
    [Country.France]: AirportList_F,
    [Country.Italy]: AirportList_IT,
    [Country.Luxembourg]: AirportList_LU,
    [Country.Netherlands]: AirportList_NL,
    [Country.Poland]: AirportList_PL,
    [Country.Slovakia]: AirportList_SK,
    [Country.Slovenia]: AirportList_SI,
    [Country.CzechRepublic]: AirportList_CZ,
};

// Country specific order
export const sortOrder_DE = [
    Country.Germany,
    Country.Austria,
    Country.Switzerland,
    Country.Belgium,
    Country.Denmark,
    Country.France,
    Country.Italy,
    Country.Luxembourg,
    Country.Netherlands,
    Country.Poland,
    Country.Slovakia,
    Country.Slovenia,
    Country.CzechRepublic,
];

export const sortOrder_AT = [
    Country.Austria,
    Country.Germany,
    Country.Switzerland,
    Country.Belgium,
    Country.Denmark,
    Country.France,
    Country.Italy,
    Country.Luxembourg,
    Country.Netherlands,
    Country.Poland,
    Country.Slovakia,
    Country.Slovenia,
    Country.CzechRepublic,
];

export const topAirports = [Iata.DUS, Iata.FRA, Iata.MUC, Iata.HAM, Iata.STR];
